export default __webpack_public_path__ + "static/media/disabled-micro.9605e04f.svg";